import { Link } from "react-router-dom";
import styled from "styled-components";

export const CtaWrapper = styled.div`

    display: flex;
    flex-direction: ${({ $imagePosition }) =>
        $imagePosition === "left" ? "row-reverse" : "row"};
    align-items: stretch;
    gap: 20px;
    padding: 40px 20px;

            @media (max-width: 768px) {
                padding: 40px 20px 20px 20px;
        }
`;

export const Cta = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 20px;
`;

export const Header = styled.h2`
    font-size: 48px;
    text-align: center;
    margin: 0;
    
    @media (max-width: 768px) {
font-size: 32px;
}
`;

export const Description = styled.p`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 16px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const CtaButton = styled(Link)`
    color: white;
    padding: 12px 24px;
    font-size: 20px;
    font-weight: 400;
    border: 2px solid hsla(93, 19%, 58%, 1.00);
    border-radius: 10px;
    cursor: pointer;
    text-decoration: none;
    margin: 0;
    transition: background-color 0.3s, border-color 0.3s;
    background-color: hsla(93, 19%, 58%, 1.00);

        &:hover {
            background-color: hsla(93, 30%, 67%, 1.00);
            border-color: hsla(93, 30%, 67%, 1.00);
        }

        @media (max-width: 768px) {
            font-size: 16px;
            padding: 10px 20px;
        }
`;

export const CtaImageWrapper = styled.div`
    flex: 1;
    max-height: 500px;
    aspect-ratio: 16/9;
    overflow: hidden;

            @media (max-width: 992px) {
                display: none;
        }
`;

export const CtaImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;